/* ══════════════════════════════════════
   IMAM DISCOUNT PROGRAM — JS
══════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Scroll-reveal animation ── */
    var reveals = document.querySelectorAll('.jci-reveal');
    if (reveals.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { observer.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ── FAQ accordion ── */
    var faqItems = document.querySelectorAll('.jci-faq__question');
    faqItems.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.jci-faq__item');
        var wasOpen = item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.jci-faq__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        // Toggle current
        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    });

    /* ── Scroll to confirmation on form success ── */
    var confirmation = document.getElementById('jciConfirmation');
    if (confirmation) {
      confirmation.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

  });
})();
